@if (isInitialized) {
  <oe-chart [title]="component.alias">
    <controller-heat-chart [isOnlyChart]="true" [component]="component">
    </controller-heat-chart>
  </oe-chart>
}
